import React from 'react'
import '../login page/hom1/style.css'
function Footer() {
    return (
        <>
            <footer id="footer">
                <div className="links">
                    <a href="https://www.facebook.com/"><i className="fab fa-facebook fa-3x text-light"></i></a>
                    <a href="https://twitter.com/login?lang=en"><i className="fab fa-twitter fa-3x text-light"></i></a>
                    <a href="https://www.instagram.com/"><i className="fab fa-instagram fa-3x text-light"></i></a>
                </div>
                <h2>OUR FOOD &copy; 2021 , All Rights Reserved</h2>
            </footer>
        </>
    )
}
export default Footer;
